import React from "react";
import {
  DISPLAY_PAYMENT_HISTORY,
  CLEAR_PAYMENTS_HISTORY,
} from "../actions/Constants";

const intialPayments = [];
const PaymentHistoryReducer = (state = intialPayments, action) => {
  switch (action.type) {
    case DISPLAY_PAYMENT_HISTORY:
      return [...state, action.payload];
      break;
    case CLEAR_PAYMENTS_HISTORY:
      return state = [];
    default:
      return state;
  }
};

export default PaymentHistoryReducer;
